import { useState } from "react";

const useAesGcmDecrypt = () => {
  const [decryptedData, setDecryptedData] = useState(null);

  // Helper function to convert base64 to ArrayBuffer
  const base64ToArrayBuffer = base64 => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  };

  // Decrypt function
  const decrypt = async (encryptedBase64, keyBase64, ivBase64) => {
    try {
      console.log("Starting decryption with correct field mapping...");
      console.log("encryptedBase64 (code):", encryptedBase64);
      console.log("keyBase64 (should be 32 bytes):", keyBase64);
      console.log("ivBase64 (should be 12 bytes):", ivBase64);

      // Convert base64 strings to ArrayBuffers
      const encryptedData = base64ToArrayBuffer(encryptedBase64);
      const keyData = base64ToArrayBuffer(keyBase64);
      const ivData = base64ToArrayBuffer(ivBase64);

      console.log("Key length:", keyData.byteLength, "bytes (should be 32)");
      console.log("IV length:", ivData.byteLength, "bytes (should be 12)");
      console.log("Encrypted data length:", encryptedData.byteLength, "bytes");

      // Verify key is 32 bytes for AES-256
      if (keyData.byteLength !== 32) {
        throw new Error(
          `Key must be 32 bytes for AES-256, but got ${keyData.byteLength} bytes`,
        );
      }

      // Import the key
      const key = await window.crypto.subtle.importKey(
        "raw",
        keyData,
        { name: "AES-GCM", length: 256 },
        false,
        ["decrypt"],
      );

      // Decrypt the data
      const decrypted = await window.crypto.subtle.decrypt(
        {
          name: "AES-GCM",
          iv: ivData,
        },
        key,
        encryptedData,
      );

      // Convert decrypted ArrayBuffer to string (should be 6-digit code)
      const decryptedText = new TextDecoder().decode(decrypted);
      console.log("Decrypted 6-digit code:", decryptedText);

      setDecryptedData(decryptedText);
      return decryptedText;
    } catch (error) {
      console.error("Decryption error:", error);
      throw error;
    }
  };

  return { decrypt, decryptedData };
};

export default useAesGcmDecrypt;
